export const GIT_HASH = process.env.VUE_APP_GIT_HASH;
